import { defineStore } from 'pinia';
import Order from '../entities/order';

export const useOrderDetailsStore = defineStore('orderDetails', {
	state: () => ({
		order: undefined,
		loading: true,
	}),
	getters: {},
	actions: {
		async fetchOrder(id) {
			this.loading = true;
			try {
				const data = await Order.getOrderDetailsById(id);
				this.order = data;
			} finally {
				this.loading = false;
			}
		},
		async refetchOrder() {
			const data = await Order.getOrderDetailsById(this.order.id);
			this.order = data;
		},
	},
});
